export default "__VITE_ASSET__oMcAMtjj__"